import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;          // "vendor" or "dept"
  invoice_date_from?: string;    // YYYY-MM-DD
  invoice_date_to?: string;      // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  dept_from?: string;
  dept_to?: string;
  payment_date_from?: string;    // YYYY-MM-DD
  payment_date_to?: string;      // YYYY-MM-DD
  invoice_no_from?: string;
  invoice_no_to?: string;
  balance_filter?: string;       // "all" or "balance_only"
  categories?: string;           // comma-separated 1~7
  include_unapproved?: boolean;
}

export interface ReportRow {
  FH08_01: string;       // vendor code
  vendor_name: string;
  FH110_37: string;      // dept code
  dept_name: string;
  FH08_02: string;       // invoice no
  FH110_11: string;      // invoice date
  FH08_11: number;       // payable amount
  FH08_12: number;       // paid amount
  FH081_03: string;      // payment no
  FH081_11: number;      // payment amount
  FH081_12: string;      // payment date
  FH081_99: number;      // balance
  FH110_PAYC: string;    // payment terms
  company_name: string;
}

export interface VendorSummary {
  code: string;
  name: string;
  count: number;
  total_payable: number;
  total_paid: number;
  total_balance: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  summaries: VendorSummary[];
  message?: string;
}

export const h302Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/h302/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/h302/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
